import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import {
  Col,
  Row,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Badge,
  Progress,
} from "reactstrap";
import Header from "components/Header/Header";
import Footer_New from "components/Footer-New/Footer-New";
import LoginModal from "components/LoginModal/LoginModal";
import { useLoginModal } from "../contexts/LoginModalContext";
import { API_STOK_DARAH } from "utils";

function StokDarah() {
  const history = useHistory();
  const { isOpen, toggleModal } = useLoginModal();

  const [stokDarah, setStokDarah] = useState([]);
  const [lastUpdate, setLastUpdate] = useState("");

  useEffect(() => {
    const fetchStok = async () => {
      try {
        const res = await axios.get(API_STOK_DARAH, { timeout: 120000 });
        if (res.data?.success && Array.isArray(res.data.data)) {
          const normalized = res.data.data.map((item) => {
            const stok = item.stok_kantung || 0;
            const target = Math.max(item.total_masuk || stok || 0, 50);
            const status = stok < target * 0.6 ? "kurang" : "cukup";
            return {
              bloodTypeID: item.bloodTypeID,
              golongan: item.golonganDarah || `ID-${item.bloodTypeID}`,
              stok,
              target,
              status,
              totalMasuk: item.total_masuk || 0,
              totalKeluar: item.total_keluar || 0,
            };
          });
          setStokDarah(normalized);
          setLastUpdate(new Date().toLocaleString());
        }
      } catch (err) {
        console.error("Error fetch stok darah:", err);
      }
    };
    fetchStok();
  }, []);

  const totalStok = useMemo(
    () => stokDarah.reduce((sum, item) => sum + (item.stok || 0), 0),
    [stokDarah]
  );

  return (
    <>
      <Header />
      <LoginModal isOpen={isOpen} toggle={toggleModal} />
      <div
        className="content"
        style={{
          margin: 20,
          background: "#ffffff",
          minHeight: "100vh",
          padding: "20px 0",
        }}
      >
        {/* Header Section */}
        <Row style={{ marginBottom: "40px" }}>
          <Col xs="12">
            <Card
              style={{
                background: "linear-gradient(135deg, #e63946 0%, #d62828 100%)",
                borderRadius: "20px",
                border: "none",
                boxShadow: "0 4px 25px rgba(230, 57, 70, 0.2)",
                padding: "40px",
                color: "#ffffff",
              }}
            >
              <h1
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "300",
                  marginBottom: "15px",
                }}
              >
                📊 Stok Darah
              </h1>
              <p style={{ fontSize: "1.1rem", opacity: 0.95, margin: 0 }}>
                Informasi stok darah terbaru dari Rumah Sakit Umum Daerah Ba'a
              </p>
            </Card>
          </Col>
        </Row>

        {/* Stok Darah Card */}
        <Row style={{ marginBottom: "30px" }}>
          <Col xs="12">
            <Card
              style={{
                borderRadius: "20px",
                border: "none",
                boxShadow: "0 2px 20px rgba(0,0,0,0.08)",
              }}
            >
              <CardHeader
                style={{
                  background: "#ffffff",
                  borderBottom: "2px solid #f1f3f5",
                  padding: "25px 30px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  <div>
                    <CardTitle
                      tag="h4"
                      style={{
                        color: "#2d3436",
                        margin: 0,
                        fontWeight: "500",
                        fontSize: "1.4rem",
                      }}
                    >
                      🏥 RSUD Ba'a
                    </CardTitle>
                    <p
                      style={{
                        margin: "8px 0 0 0",
                        color: "#636e72",
                        fontSize: "0.95rem",
                      }}
                    >
                      📍 Jl. Raya Ba'a, Kec. Ba'a
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      flexWrap: "wrap",
                    }}
                  >
                    <Badge
                      style={{
                        background: "#f8f9fa",
                        color: "#636e72",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        fontSize: "0.85rem",
                        fontWeight: "400",
                      }}
                    >
                      Total stok: {totalStok} kantong
                    </Badge>
                    <Badge
                      style={{
                        background: "#f8f9fa",
                        color: "#636e72",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        fontSize: "0.85rem",
                        fontWeight: "400",
                      }}
                    >
                      Update: {lastUpdate || "-"}
                    </Badge>
                  </div>
                </div>
              </CardHeader>
              <CardBody style={{ padding: "30px" }}>
                {stokDarah.length === 0 ? (
                  <div
                    style={{
                      textAlign: "center",
                      color: "#636e72",
                      padding: "10px 0",
                    }}
                  >
                    Tidak ada data stok darah.
                  </div>
                ) : (
                  <Row>
                    {stokDarah.map((item) => (
                      <Col
                        lg="3"
                        md="6"
                        sm="12"
                        key={item.bloodTypeID}
                        style={{ marginBottom: "20px" }}
                      >
                        <Card
                          style={{
                            border: `2px solid ${
                              item.status === "kurang" ? "#ffe0e0" : "#e0f5e9"
                            }`,
                            borderRadius: "16px",
                            padding: "25px 20px",
                            textAlign: "center",
                            background:
                              item.status === "kurang" ? "#fff5f5" : "#f8fff9",
                            transition: "all 0.3s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform =
                              "translateY(-3px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 15px rgba(0,0,0,0.1)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <h3
                            style={{
                              fontSize: "2.5rem",
                              fontWeight: "300",
                              color:
                                item.status === "kurang"
                                  ? "#e63946"
                                  : "#06d6a0",
                              margin: "10px 0",
                              letterSpacing: "2px",
                            }}
                          >
                            {item.golongan}
                          </h3>
                          <p
                            style={{
                              fontSize: "1rem",
                              margin: "15px 0",
                              color: "#636e72",
                            }}
                          >
                            <strong
                              style={{
                                color: "#2d3436",
                                fontSize: "1.4rem",
                              }}
                            >
                              {item.stok}
                            </strong>{" "}
                            / {item.target} kantong
                          </p>
                          <Progress
                            value={(item.stok / item.target) * 100}
                            color={
                              item.status === "kurang" ? "danger" : "success"
                            }
                            style={{
                              height: "10px",
                              borderRadius: "10px",
                              marginTop: "15px",
                              backgroundColor: "#f1f3f5",
                            }}
                          />
                          <Badge
                            style={{
                              marginTop: "15px",
                              fontSize: "0.85rem",
                              padding: "6px 12px",
                              borderRadius: "20px",
                              fontWeight: "400",
                              background:
                                item.status === "kurang"
                                  ? "#ffe0e0"
                                  : "#e0f5e9",
                              color:
                                item.status === "kurang"
                                  ? "#e63946"
                                  : "#06d6a0",
                              border: "none",
                            }}
                          >
                            {item.status === "kurang"
                              ? "⚠️ Stok Kurang"
                              : "✅ Stok Cukup"}
                          </Badge>
                          <div
                            style={{
                              marginTop: "10px",
                              fontSize: "0.85rem",
                              color: "#636e72",
                            }}
                          >
                            Masuk: {item.totalMasuk} | Keluar:{" "}
                            {item.totalKeluar}
                          </div>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      <Footer_New />
    </>
  );
}

export default StokDarah;
